module.exports = __webpack_public_path__ + "static/img/9.96cc429.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/2/zh/9.png
// module id = q0Cm
// module chunks = 0